import * as React from 'react';
import { Container } from 'types/Watchlist';
import { formatDemurrage } from 'utils/container-transforms';
import { DualCell } from './DualCell';
import { CellProps } from './types';

/**
 * Show the demurrage due for a container
 * TODO: This does not show if its been paid since we do not have that data
 */
export const Demurrage: React.FC<CellProps> = (props) => {
  const container: Container = props.row;
  const demurrageDue = formatDemurrage(container);

  const topText = demurrageDue?.value;
  const bottomText = demurrageDue?.meta?.demurrageDue ? 'Demurrage due' : '';

  return (
    <DualCell
      topText={topText}
      bottomText={bottomText}
      showBottomText
      bottomTextRed={demurrageDue?.meta?.demurrageDue}
    />
  );
};
Demurrage.displayName = 'ContainerTable.Demurrage';
